import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{add-body-classes \'SH-r-reports\'}}\n\n{{outlet}}",{ moduleName: "sh-www/templates/reports.hbs" })